"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { classNames, FlexCenter, FlexColumn, Separator } from "@opensea/ui-kit";
import { ArrowDownward } from "@opensea/ui-kit/icons";
import { LayoutGroup } from "motion/react";
import { useCallback, useMemo } from "react";
import { Controller, useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../components/Button";
import { CurrencyQuantityInput } from "../../../../components/CurrencyQuantityInput/CurrencyQuantityInput";
import { useAccount, useAddress, useConnect, useConnections } from "../../../../polychain/hooks";
import { useSwapGasCheck } from "../hooks/useSwapGasCheck";
import { useSwapContext } from "../provider/SwapContext";

// Getting Currency in a non-circular way

export const SwapPanel = t0 => {
  const $ = _c(71);
  const {
    surface,
    onChangeFromCurrency: onChangeFromCurrencyProp,
    onChangeToQuantity: onChangeToQuantityProp,
    onChangeToCurrency: onChangeToCurrencyProp,
    autoFocusFromCurrency: t1,
    enableUsdInput: t2
  } = t0;
  const autoFocusFromCurrency = t1 === undefined ? true : t1;
  const enableUsdInput = t2 === undefined ? false : t2;
  const {
    isLoadingQuote,
    container,
    actions,
    variant,
    isLoadingInitialToCurrency,
    isLoadingInitialFromCurrency,
    quote,
    isCurrencySelectionDisabled,
    actionsStatus
  } = useSwapContext();
  const t = useTranslations("wallet.SwapPanel");
  const {
    hasGas,
    gasSymbol
  } = useSwapGasCheck();
  const {
    getChain
  } = useChains();
  const {
    chainArch
  } = useAccount();
  const connections = useConnections();
  const {
    connect
  } = useConnect();
  const {
    control,
    setValue
  } = useFormContext();
  let t3;
  if ($[0] !== control) {
    t3 = {
      control
    };
    $[0] = control;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    errors
  } = useFormState(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["fromCurrency", "fromQuantity", "toCurrency", "toQuantity"];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== control) {
    t5 = {
      control,
      name: t4
    };
    $[3] = control;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const [fromCurrency, fromQuantity, toCurrency, toQuantity] = useWatch(t5);
  const route = quote?.swapRoutes[0];
  let t6;
  bb0: {
    if (route?.__typename === "SwapRoute") {
      t6 = route.pricePerFromAsset.usd;
      break bb0;
    }
    t6 = undefined;
  }
  const fromUsdValue = t6;
  let t7;
  bb1: {
    if (route?.__typename === "SwapRoute") {
      t7 = route.pricePerToAsset.usd;
      break bb1;
    }
    t7 = undefined;
  }
  const toUsdValue = t7;
  const activeAddress = useAddress();
  let t8;
  if ($[5] !== activeAddress || $[6] !== errors.fromQuantity?.message || $[7] !== gasSymbol || $[8] !== hasGas || $[9] !== t) {
    t8 = () => {
      const generalError = errors.fromQuantity?.message;
      const gasError = !hasGas && activeAddress ? t("insufficientGas", {
        symbol: gasSymbol ?? ""
      }) : undefined;
      return generalError ?? gasError;
    };
    $[5] = activeAddress;
    $[6] = errors.fromQuantity?.message;
    $[7] = gasSymbol;
    $[8] = hasGas;
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const getFromError = t8;
  let t9;
  if ($[11] !== chainArch || $[12] !== connect || $[13] !== connections || $[14] !== getChain) {
    t9 = currency => {
      const newArch = getChain(currency.chainIdentifier)?.arch;
      if (newArch && newArch !== chainArch) {
        const newConnection = connections.find(c => c.chainArch === newArch);
        if (newConnection) {
          connect(newConnection.connector);
        }
      }
    };
    $[11] = chainArch;
    $[12] = connect;
    $[13] = connections;
    $[14] = getChain;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const checkOrUpdateFromCurrencyWallet = t9;
  let t10;
  if ($[16] !== actions || $[17] !== actionsStatus.isLoading || $[18] !== actionsStatus.isPending || $[19] !== autoFocusFromCurrency || $[20] !== checkOrUpdateFromCurrencyWallet || $[21] !== container || $[22] !== control || $[23] !== enableUsdInput || $[24] !== fromQuantity || $[25] !== fromUsdValue || $[26] !== getFromError || $[27] !== isCurrencySelectionDisabled || $[28] !== isLoadingInitialFromCurrency || $[29] !== onChangeFromCurrencyProp || $[30] !== surface || $[31] !== variant) {
    t10 = t11 => {
      const {
        field: fromQuantityField
      } = t11;
      return <Controller control={control} name="fromCurrency" render={t12 => {
        const {
          field: fromCurrencyField
        } = t12;
        return <CurrencyQuantityInput container={container} currency={fromCurrencyField.value} direction="from" disableCurrencySelection={isCurrencySelectionDisabled} enableUsdInput={enableUsdInput} error={fromQuantityField.value && fromQuantityField.value > 0 && actions.length === 0 ? getFromError() : undefined} isDisabled={actionsStatus.isPending || actionsStatus.isLoading} isLoadingCurrency={isLoadingInitialFromCurrency} isSwapContext={true} onCurrencyChange={value => {
          onChangeFromCurrencyProp?.(value, fromCurrencyField.value);
          fromCurrencyField.onChange(value);
          checkOrUpdateFromCurrencyWallet(value);
        }} onQuantityChange={value_0 => {
          fromQuantityField.onChange(value_0);
        }} overrides={{
          Input: {
            autoFocus: autoFocusFromCurrency
          }
        }} quantity={fromQuantity} surface={surface} usdValue={fromUsdValue} variant={variant} />;
      }} />;
    };
    $[16] = actions;
    $[17] = actionsStatus.isLoading;
    $[18] = actionsStatus.isPending;
    $[19] = autoFocusFromCurrency;
    $[20] = checkOrUpdateFromCurrencyWallet;
    $[21] = container;
    $[22] = control;
    $[23] = enableUsdInput;
    $[24] = fromQuantity;
    $[25] = fromUsdValue;
    $[26] = getFromError;
    $[27] = isCurrencySelectionDisabled;
    $[28] = isLoadingInitialFromCurrency;
    $[29] = onChangeFromCurrencyProp;
    $[30] = surface;
    $[31] = variant;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== control || $[34] !== t10) {
    t11 = <Controller control={control} name="fromQuantity" render={t10} />;
    $[33] = control;
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Separator className="flex-1" />;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = classNames("flex items-center justify-center", "size-8 rounded-full p-1.5");
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  const t14 = !toCurrency;
  let t15;
  if ($[38] !== fromCurrency || $[39] !== onChangeFromCurrencyProp || $[40] !== onChangeToCurrencyProp || $[41] !== setValue || $[42] !== toCurrency) {
    t15 = () => {
      if (toCurrency) {
        setValue("fromCurrency", toCurrency);
        onChangeFromCurrencyProp?.(toCurrency, fromCurrency);
        setValue("toCurrency", fromCurrency);
        onChangeToCurrencyProp?.(fromCurrency, toCurrency);
        setValue("fromQuantity", 0, {
          shouldValidate: true
        });
        setValue("toQuantity", 0, {
          shouldValidate: true
        });
      }
    };
    $[38] = fromCurrency;
    $[39] = onChangeFromCurrencyProp;
    $[40] = onChangeToCurrencyProp;
    $[41] = setValue;
    $[42] = toCurrency;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  const t16 = variant === "frosted" ? "frosted" : "secondary";
  let t17;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ArrowDownward size={20} />;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t14 || $[46] !== t15 || $[47] !== t16) {
    t18 = <Button className={t13} disabled={t14} onClick={t15} variant={t16}>{t17}</Button>;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Separator className="flex-1" />;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t18) {
    t20 = <FlexCenter>{t12}{t18}{t19}</FlexCenter>;
    $[50] = t18;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== container || $[53] !== errors.toQuantity?.message || $[54] !== isCurrencySelectionDisabled || $[55] !== isLoadingInitialToCurrency || $[56] !== isLoadingQuote || $[57] !== onChangeToCurrencyProp || $[58] !== onChangeToQuantityProp || $[59] !== surface || $[60] !== toQuantity || $[61] !== toUsdValue || $[62] !== variant) {
    t21 = t22 => {
      const {
        field: toCurrencyField
      } = t22;
      return <CurrencyQuantityInput container={container} currency={toCurrencyField.value} direction="to" disableCurrencySelection={isCurrencySelectionDisabled} error={errors.toQuantity?.message} isDisabled={true} isLoading={isLoadingQuote} isLoadingCurrency={isLoadingInitialToCurrency} isSwapContext={true} onCurrencyChange={value_1 => {
        onChangeToCurrencyProp?.(value_1, toCurrencyField.value);
        toCurrencyField.onChange(value_1);
      }} onQuantityChange={value_2 => {
        onChangeToQuantityProp?.(value_2, toQuantity);
      }} quantity={toQuantity} surface={surface} usdValue={toUsdValue} variant={variant} />;
    };
    $[52] = container;
    $[53] = errors.toQuantity?.message;
    $[54] = isCurrencySelectionDisabled;
    $[55] = isLoadingInitialToCurrency;
    $[56] = isLoadingQuote;
    $[57] = onChangeToCurrencyProp;
    $[58] = onChangeToQuantityProp;
    $[59] = surface;
    $[60] = toQuantity;
    $[61] = toUsdValue;
    $[62] = variant;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  let t22;
  if ($[64] !== control || $[65] !== t21) {
    t22 = <Controller control={control} name="toCurrency" render={t21} />;
    $[64] = control;
    $[65] = t21;
    $[66] = t22;
  } else {
    t22 = $[66];
  }
  let t23;
  if ($[67] !== t11 || $[68] !== t20 || $[69] !== t22) {
    t23 = <FlexColumn className="relative"><LayoutGroup>{t11}{t20}{t22}</LayoutGroup></FlexColumn>;
    $[67] = t11;
    $[68] = t20;
    $[69] = t22;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  return t23;
};